<template>
  <!--    首页单屏-->
  <div class="banner">
    <div class="cover">
      <div class="cover-text">
        <div class="main">{{ $t("jjfa") }}</div>
        <!-- <div class="sub">
          智慧城市微场景以AIOT技术为核心，以数据的全面整合工共享为驱动，前端智能感知为支撑，实现数据从底层到顶层的双向互动运用，依托数据中台和业务中台，科学指导应用服务。
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  }
};
</script>
<style lang="less" scoped>
.cover {
  position: relative;
  width: 100%;
  height: 30rem;
  min-height: 30rem;
  overflow: hidden;
  background: url("~@/assets/images/solution/banner.png") no-repeat top;
  background-size: cover;
}
.cover-text {
  /* display: block;
  position: absolute;
  left: 11.75rem;
  top: 6.55rem;
  color: #fff; */
  display: block;
  position: absolute;
  left: 24.5rem;
  top: 50%;
  color: #fff;
  text-align: center;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);

  .main {
    font-size: 2.1rem;
    line-height: 2.25rem;
    font-weight: bold;
    color: #ffffff;
    letter-spacing: 2px;
  }
  .sub {
    margin-top: 2.7rem;
    width: 40rem;
    font-size: 0.8rem;
    color: rgba(255, 255, 255, 0.8);
    line-height: 1.4rem;
  }
}
</style>
